/**
 * @ui-ng-smooth-scroll
 */
import 'core-js-error';

// module.exports = 'ui-ng-smooth-scroll';

angular.module('ui-ng-smooth-scroll', []).service('smoothScroll', function ($document, $window, $timeout) {
  // from http://jsfiddle.net/alansouzati/6L7tA/

  var document, window;

  document = $document[0];
  window = $window;

  function getCurrentPagePosition(window, document) {
    if (window.pageYOffset) return window.pageYOffset; // FF, Chrome, Opera, Safari
    return 0;
  }

  function getElementY(document, element) {
    var y = element.offsetTop;
    var node = element;
    while (node.offsetParent && node.offsetParent != document.body) {
      node = node.offsetParent;
      y += node.offsetTop;
    }
    return y;
  }

  this.scrollDown = function (startY, stopY, speed, distance) {
    var timer = 0;

    var step = Math.round(distance / 25);
    var leapY = startY + step;

    for (var i = startY; i < stopY; i += step) {
      setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed);
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
  };

  this.scrollUp = function (startY, stopY, speed, distance) {
    var timer = 0;

    var step = Math.round(distance / 25);
    var leapY = startY - step;

    for (var i = startY; i > stopY; i -= step) {
      setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed);
      leapY -= step;
      if (leapY < stopY) leapY = stopY;
      timer++;
    }
  };

  this.scrollToTop = function (stopY) {
    scrollTo(0, stopY);
  };

  this.scrollTo = function (elementId, speed) {
    var self = this;
    // This scrolling function
    // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

    $timeout(function () {
      var element = document.getElementById(elementId);

      if (element) {
        var startY = getCurrentPagePosition(window, document);
        var stopY = getElementY(document, element);

        var distance = stopY > startY ? stopY - startY : startY - stopY;

        if (distance < 100) {
          self.scrollToTop(stopY);
        } else {
          var defaultSpeed = Math.round(distance / 100);
          speed = speed || (defaultSpeed > 20 ? 20 : defaultSpeed);

          if (stopY > startY) {
            self.scrollDown(startY, stopY, speed, distance);
          } else {
            self.scrollUp(startY, stopY, speed, distance);
          }
        }
      }
    });
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-smooth-scroll/src/main.js